/**
 *
 * Asynchronously loads the component for BranchSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const CommunicationSetup = lazyLoad(
  () => import('./index'),
  module => module.CommunicationSetup,
);
